import React, { useCallback } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dateFormatter } from "@services/dayjs";

const DateInput = ({
  id = `date-${Date.now()}`,
  onChange = null,
  onFocus = null,
  onSelect = null,
  filterDates = null,
  placeholder = "",
  dateFormat = "ll",
  classes = "",
  selected = null,
  label = null,
  disabled = false,
  error = false,
  name = "",
  tabIndex = 0,
  readOnly = false,
  inline = false,
  shouldCloseOnSelect = true,
  onMonthChange = null,
  disabledKeyboardNavigation = false,
  minDate = null,
  onClickOutside = () => "",
  ...rest
}) => {
  const onChangeDate = useCallback((dateObj) =>
    typeof onChange === "function" ? onChange({ name, value: dateFormatter(dateObj) }) : ""
  );
  const onSelectDate = useCallback((dateObj) => {
    if (typeof onSelect === "function") onSelect({ name, value: dateFormatter(dateObj) });
    //onBlur event is not getting fired.So added this to close the calendar on date select.
    if (typeof onClickOutside === "function") onClickOutside();
  });
  return (
    <div className={`form-input ${error ? "form-input-error" : ""}`}>
      {label && (
        <label htmlFor={label.for} className={label.classes}>
          <span>{label.content}</span>
        </label>
      )}
      <DatePicker
        selected={selected?.toDate()}
        onClickOutside={onClickOutside}
        disabledKeyboardNavigation={disabledKeyboardNavigation}
        dateFormat={dateFormat}
        shouldCloseOnSelect={shouldCloseOnSelect}
        onMonthChange={onMonthChange}
        id={id}
        readOnly={readOnly}
        tabIndex={tabIndex}
        disabled={disabled}
        inline={inline}
        placeholderText={placeholder}
        className={classes}
        onChange={onChangeDate}
        onFocus={() => (typeof onFocus === "function" ? onFocus() : "")}
        onSelect={onSelectDate}
        filterDate={(date) => (typeof filterDates === "function" ? filterDates(date) : true)}
        minDate={minDate?.toDate()}
        {...rest}
      />
    </div>
  );
};

export default DateInput;
